import { FormControl, FormLabel, FormHelperText, Flex, Badge, Text, Box } from '@chakra-ui/react'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import { CUSTOM_FORM_ENTITY_NAME, CUSTOM_FORM_KIND_NAME } from 'components/tools/CustomForm/constants'
import CustomFormViewerQuestionSelection from './components/CustomFormViewerQuestionSelection'
import { useCustomFormViewer } from '../../contexts/CustomFormViewerManager/Provider'

type QuestionProps = {
  question: CustomFormQuestion
  disabled?: boolean
  index: number
  questionsLength: number
}

export default function CustomFormViewerQuestion({ question, index, questionsLength, disabled }: QuestionProps) {
  const { thisQuestionHasError } = useCustomFormViewer()

  const questionError = thisQuestionHasError(question.slug)

  return (
    <Flex
      p={2}
      bg="bgContent"
      rounded="md"
      borderWidth="2px"
      className="accessible"
      cursor="initial"
      borderColor={questionError?.hasError ? 'danger' : 'transparent'}
    >
      <FormControl gap={2}>
        <Flex align="center" justify="space-between" borderBottom="1px solid" borderColor="borderColor" pb={2} mb={2}>
          <Flex align="center" gap={1}>
            <Badge>{CUSTOM_FORM_KIND_NAME[question?.kind || 'Desconhecido']}</Badge>
            {question?.entity && <Badge>{CUSTOM_FORM_ENTITY_NAME[question?.entity || 'Desconhecido']}</Badge>}
          </Flex>
          <Text variant="secondary">
            <Text as="span">{Number(index) + 1}</Text>
            <Text as="span">/{questionsLength}</Text>
          </Text>
        </Flex>
        <FormLabel mb={question?.description ? 0 : 2}>
          {question?.title || 'Questão sem título'}{' '}
          {question.is_required && (
            <Box as="span" color="danger" fontSize="xs">
              (obrigatório)
            </Box>
          )}
        </FormLabel>
        {question?.description && <FormHelperText>{question?.description}</FormHelperText>}
        <CustomFormViewerQuestionSelection question={question} disabled={disabled} />
      </FormControl>
    </Flex>
  )
}
